export default "__VITE_ASSET__IWGDQkNz__"